import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { useSelector } from 'react-redux';
import type { RootState } from '@store/index';

export const Layout: React.FC = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { sidebarOpen } = useSelector((state: RootState) => state.ui);

  return (
    <div className="min-h-screen bg-ncaa-light">
      <Header />
      
      <div className="flex">
        {isAuthenticated && (
          <Sidebar isOpen={sidebarOpen} />
        )}
        
        <main 
          className={`
            flex-1 
            ${isAuthenticated ? 'lg:ml-64' : ''}
            ${isAuthenticated && sidebarOpen ? 'ml-64' : ''} 
            transition-all duration-300 ease-in-out
          `}
        >
          <div className="min-h-screen pb-16">
            <Outlet />
          </div>
        </main>
      </div>
      
      <Footer />
      
      {/* Toast notifications */}
      <Toaster
        position="top-right"
        toastOptions={{
          className: '',
          duration: 4000,
          style: {
            background: '#fff',
            color: '#1f2937',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </div>
  );
};
